/**
 * @generated SignedSource<<0c94eec672b6d010c1ce6416e9462baa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type watches_nativeIssueTable_WatchersCell$data = {
  readonly __typename: "JiraWatchesField";
  readonly watch: {
    readonly count: AGG$Long | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "watches_nativeIssueTable_WatchersCell";
};
export type watches_nativeIssueTable_WatchersCell$key = {
  readonly " $data"?: watches_nativeIssueTable_WatchersCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"watches_nativeIssueTable_WatchersCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "watches_nativeIssueTable_WatchersCell",
  "selections": [
    {
      "concreteType": "JiraWatch",
      "kind": "LinkedField",
      "name": "watch",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "count"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "__typename"
    }
  ],
  "type": "JiraWatchesField"
};

(node as any).hash = "11e8e23cad0b2847fb46e07cdb08cdc5";

export default node;
